export const text = {
  title: 'Variantes',
  subtitle:
    'Agrega información que complemente los detalles de tu producto para identificarlos de mejor manera. Puedes crear distintas combinaciones si tienes más de 1 opción.'
};
